import React from 'react';
import { Caption } from '@randajan/jet-react/dom/caption';
import { Reveal } from '../../../elements/Reveal/Reveal';

import "./About.scss";

export const About = (props)=>{
    const { content } = props;
    
    return (
        <article className="About">
            <Reveal as="header">
                <Caption>Proč ENERGOSPACE</Caption>
                <p>{content.finalStatement}</p>
            </Reveal>
            <div className="About__grid">
                {content.whyItems.map((item, index)=>(
                    <Reveal as="section" className="About__item" key={item.title} delay={index * 60}>
                        <h3>{item.title}</h3>
                        {item.text && <p>{item.text}</p>}
                        {item.items && (
                            <ul>
                                {item.items.map(value=><li key={value}>{value}</li>)}
                            </ul>
                        )}
                    </Reveal>
                ))}
            </div>
        </article>
    )
}

